import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import useFetch from "@/lib/useFetch";
import api from "@/lib/api";
import { PageHeader, Footer, SectionCard } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function Settings() {
    const { data } = useFetch("/admin/settings/network");
    const [form, setForm] = useState(null);
    useEffect(() => { if (data) setForm(data); }, [data]);
    if (!form) return <Loader />;
    const upd = (k, v) => setForm({ ...form, [k]: v });

    const save = async () => {
        try { await api.post("/admin/settings/network", form); toast.success("Network settings saved"); }
        catch (e) { toast.error("Save failed", { description: e.response?.data?.detail || "" }); }
    };

    return (
        <div data-testid="admin-settings">
            <PageHeader title="Settings" subtitle="Network-wide configuration." />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <SectionCard title="Branding" testId="settings-branding">
                    <div className="space-y-3">
                        <Field label="Network Name"><Input data-testid="settings-network-name" value={form.network_name} onChange={(e) => upd("network_name", e.target.value)} className="bg-background border-border" /></Field>
                        <Field label="Footer / Legal Disclaimer"><Textarea data-testid="settings-footer" value={form.footer} onChange={(e) => upd("footer", e.target.value)} className="bg-background border-border" rows={4} /></Field>
                    </div>
                </SectionCard>
                <SectionCard title="Currency Labels" testId="settings-currency">
                    <div className="space-y-3">
                        <Field label="Primary (Scrap)"><Input value={form.scrap_label} onChange={(e) => upd("scrap_label", e.target.value)} className="bg-background border-border" /></Field>
                        <Field label="Premium (HC)"><Input value={form.hc_label} onChange={(e) => upd("hc_label", e.target.value)} className="bg-background border-border" /></Field>
                        <Field label="Credits"><Input value={form.credits_label} onChange={(e) => upd("credits_label", e.target.value)} className="bg-background border-border" /></Field>
                    </div>
                </SectionCard>
            </div>
            <Button data-testid="settings-save" onClick={save} className="mt-5 font-heading uppercase bg-hazard text-black hover:bg-hazard/90"><Save size={15} className="mr-1" /> Save Settings</Button>
            <Footer />
        </div>
    );
}

function Field({ label, children }) {
    return <div><label className="label-mono text-muted-foreground">{label}</label><div className="mt-1">{children}</div></div>;
}
